import { render, staticRenderFns } from "./StakingPoolType.vue?vue&type=template&id=3500d9b7&scoped=true&"
import script from "./StakingPoolType.vue?vue&type=script&lang=js&"
export * from "./StakingPoolType.vue?vue&type=script&lang=js&"
import style0 from "./StakingPoolType.vue?vue&type=style&index=0&id=3500d9b7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3500d9b7",
  null
  
)

export default component.exports